import { type Option } from '@avanta/shared/components/ui/Select';
import { LOCIZE_NS, QUERY_KEYS } from '@avanta/shared/constants/common';
import { CenterService } from '@avanta/shared/services/centers';
import { type Center } from '@avanta/shared/types/centers';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';
import { useFetchEnterpriseContracts } from 'hooks/useFetchEnterpriseContracts';
import { useEnterpriseId } from 'stores/user';

const useFetchCenters = (): UseQueryResult<Center[], Error> => {
  const enterpriseId = useEnterpriseId();
  return useQuery<AxiosResponse<Center[]>, Error, Center[]>({
    queryKey: [QUERY_KEYS.FETCH_CENTERS, enterpriseId],
    queryFn: () => CenterService.getCentersByEnterprise(enterpriseId ?? ''),
    enabled: Boolean(enterpriseId),
    select: response => response.data,
  });
};
export const useGetOptions = (): {
  contractsIds: Option[];
  centersIds: Option[];
} => {
  const { data: contracts } = useFetchEnterpriseContracts();
  const { data: centers } = useFetchCenters();

  return {
    contractsIds:
      contracts?.map(contract => ({
        value: String(contract.id),
        label: contract.title,
        description: contract.tenderNumber,
        ns: LOCIZE_NS.INSURANCE,
      })) ?? [],
    centersIds:
      centers?.map(center => ({
        value: String(center.id),
        label: center.centerName,
        description: `${center.address} ${center.postalCode} ${center.city}`,
        ns: LOCIZE_NS.INSURANCE,
      })) ?? [],
  };
};
